var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _g3, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegalSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_25",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 30,
    width: 500,
    height: 542
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 30H551V571.905H51V30Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.003 70.8188C366.895 69.6907 319.276 39.5641 303.007 29.0195C286.738 39.5641 239.123 69.6907 178.016 70.8188C110.956 72.3258 68.8945 56.8857 53.0244 46.72V253.835C53.0244 384.886 160.159 532.88 303.007 571.291C374.431 552.087 437.126 505.388 481.57 447.395C526.008 389.403 552.994 319.358 552.994 253.835V46.72C537.119 56.8857 495.058 72.3258 428.003 70.8188ZM533.008 253.835C533.008 312.207 508.561 381.021 466.5 436C424.443 490.979 362.132 534.856 303.007 552.931C243.487 535.231 181.562 492.604 139.5 438C97.439 383.396 71.0053 312.207 71.0053 253.835V74.1307C99.973 82.036 139.13 88.8034 169.287 88.4246H178.81C220.472 87.2965 262.932 70.4915 303.007 47.1462C343.086 70.4915 385.542 87.2965 427.209 88.0499H436.731C466.888 88.4246 504.045 82.6614 533.008 74.7519L534.008 164.293L533.008 253.835Z",
    fill: "#081F42"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M438.646 419.02H161.702C156.25 419.02 151.38 422.492 149.857 427.463L147.891 433.879H452.458L450.492 427.463C448.968 422.492 444.098 419.02 438.646 419.02Z",
    fill: "#081F42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M290.889 150.094H309.46V159.321H290.889V150.094Z",
    fill: "#081F42"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_28_25",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 281,
    y: 98,
    width: 38,
    height: 48
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M281.855 98.9902H318.522V145.268H281.855V98.9902Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_28_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.064 144.598C315.68 139.781 318.431 132.333 318.431 124.36C318.431 110.371 310.241 98.9902 300.173 98.9902C290.104 98.9902 281.914 110.371 281.914 124.36C281.914 132.33 284.665 139.778 289.281 144.598H311.064Z",
    fill: "#081F42"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M290.889 164.801H309.46V377.134H290.889V164.801Z",
    fill: "#081F42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223.428 398.746C218.063 398.746 213.265 402.16 211.764 407.047L209.775 413.528H390.573L388.584 407.047C387.083 402.16 382.285 398.746 376.921 398.746H223.428Z",
    fill: "#081F42"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M287.992 382.633H255.469V393.26H344.87V382.633H287.992Z",
    fill: "#081F42"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_28_25",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 148,
    width: 163,
    height: 193
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.75 148.434H285.186V340.613H123.75V148.434Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_28_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.258 304.236H233.162L202.437 190.083C204.972 190.506 207.508 190.753 210.002 190.753C221.75 190.753 230.796 187.429 239.549 184.213C246.502 181.658 253.071 179.243 260.067 179.026C270.373 178.699 279.728 183.033 285.099 186.163V163.944C280.809 162.563 267.905 158.915 256.356 160.79C250.337 161.766 244.507 164.738 238.332 167.886C229.715 172.276 220.809 176.814 209.998 176.814C197.515 176.814 190.597 172.675 187.199 169.656C186.024 170.914 184.657 172.023 183.075 172.882C181.691 173.635 179.924 173.178 179.129 171.862C178.332 170.549 178.817 168.872 180.2 168.118C183.537 166.301 185.61 162.913 185.61 159.273C185.61 153.657 180.796 149.088 174.878 149.088C168.963 149.088 164.152 153.657 164.152 159.273C164.152 164.667 167.456 170.336 172.674 175.356L137.987 304.236H123.892C126.157 324.22 152.957 340.044 185.575 340.044C218.192 340.044 244.995 324.22 247.258 304.236ZM227.16 304.236H188.468V185.77C190.916 186.87 193.446 187.809 196.027 188.572L227.16 304.236ZM182.684 182.826V304.236H143.993L177.58 179.45C179.194 180.636 180.884 181.779 182.684 182.826Z",
    fill: "#081F42"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M462.36 304.242L427.669 175.366C432.887 170.343 436.195 164.68 436.195 159.283C436.195 153.667 431.38 149.098 425.466 149.098C419.548 149.098 414.733 153.667 414.733 159.283C414.733 162.925 416.807 166.314 420.143 168.128C421.53 168.878 422.008 170.559 421.217 171.872C420.423 173.188 418.652 173.642 417.269 172.891C415.69 172.033 414.32 170.924 413.148 169.666C409.749 172.681 402.826 176.821 390.345 176.821C379.535 176.821 370.628 172.286 362.012 167.896C355.837 164.751 350.007 161.776 343.988 160.8C332.441 158.922 319.538 162.573 315.244 163.954V186.179C320.615 183.058 329.971 178.736 340.277 179.033C347.272 179.252 353.841 181.665 360.794 184.22C369.544 187.436 378.594 190.76 390.342 190.76C392.839 190.76 395.374 190.513 397.907 190.09L367.181 304.242H353.086C355.352 324.227 382.152 340.05 414.769 340.05C447.386 340.05 474.186 324.227 476.452 304.242H462.36ZM422.767 179.456L456.357 304.242H417.666V182.833C419.46 181.786 421.152 180.642 422.767 179.456ZM411.878 185.777V304.242H373.187L404.316 188.582C406.898 187.816 409.43 186.877 411.878 185.777Z",
    fill: "#081F42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalSecurity);
export default __webpack_public_path__ + "static/media/LegalSecurity.ddd73719040cf333dced98a7281226ca.svg";
export { ForwardRef as ReactComponent };